/* istanbul ignore next */
export const shorten = (text: string, maxLength: number, suffix: string = '') => {
  if (text.length <= maxLength) {
    return text;
  }
  const trimmedText = text.substr(0, maxLength - suffix.length);
  return `${trimmedText}${suffix}`;
};
